import React from 'react';
import styled from 'styled-components';

const GrayDiv = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  right: 0;
  position: fixed;
  z-index: 1000;
  cursor: wait;
`;

export const grayOverlay = (isHidden) => <GrayDiv hidden={!isHidden} />;

export const LoadingIcon = () => <i className="fas fa-spinner fa-spin" />;
